import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

/**
 * Guards a route so only authenticated users with role === "admin" can see it.
 * - Unauthenticated → /login
 * - Non-admin → /dashboard (their app area), with a flash flag in sessionStorage
 *   so the destination can show a toast if it wants.
 */
export default function AdminGuard({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-[#050505] flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-[#00E5FF] border-t-transparent animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "admin") {
    try {
      sessionStorage.setItem("admin_blocked", "1");
    } catch (err) {
      console.warn("AdminGuard: sessionStorage write failed", err);
    }
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}
